import React from 'react';
import { Link } from 'react-router-dom';
import { IBulletin } from '../../../app/models/bulletin';
import { Table} from 'semantic-ui-react';

interface IProps {
    bulletin: IBulletin
}

const BulletinTableMobileRow: React.FC<IProps> = ({ bulletin }) => {
    return (
            <Table.Row>
                <Table.Cell width={8}>
                    <a href={bulletin.filePath}> {bulletin.title} </a>
                </Table.Cell>
                <Table.Cell width={8} textAlign="right">
                </Table.Cell>
            </Table.Row>
        )
};

export default BulletinTableMobileRow;